<template>
  <div class="col-span-12 xxl:col-span-12 grid grid-cols-12 gap-6">
    <!-- BEGIN: Weekly Top Seller -->
    <div class="col-span-12 sm:col-span-6 lg:col-span-6 mt-8">
      <div class="intro-y flex items-center h-10">
        <h2 class="text-lg font-medium truncate mr-5">Total Registration Stat</h2>
        <a href="" class="ml-auto text-theme-1 dark:text-theme-10 truncate"
        >See all</a
        >
      </div>
      <div class="intro-y box p-5 mt-5">
        <ReportPieChart :height="210" class="mt-3" :registered="getRegisteredUsers()" :paid="getPaidUsers()"/>
        <div class="mt-8">
          <div class="flex items-center">
            <div class="w-2 h-2 bg-theme-11 rounded-full mr-3"></div>
            <span class="truncate">Registered</span>
            <div
                class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"
            ></div>
            <span class="font-medium xl:ml-auto">{{ getRegisteredUsers() }}</span>
          </div>
          <div class="flex items-center mt-4">
            <div class="w-2 h-2 bg-theme-1 rounded-full mr-3"></div>
            <span class="truncate">Paid</span>
            <div
                class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"
            ></div>
            <span class="font-medium xl:ml-auto">{{ getPaidUsers() }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- END: Weekly Top Seller -->
    <!-- BEGIN: Sales Report -->
<!--    <div class="col-span-12 sm:col-span-6 lg:col-span-3 mt-8">-->
<!--      <div class="intro-y flex items-center h-10">-->
<!--        <h2 class="text-lg font-medium truncate mr-5">Sales Report</h2>-->
<!--        <a href="" class="ml-auto text-theme-1 dark:text-theme-10 truncate"-->
<!--        >See all</a-->
<!--        >-->
<!--      </div>-->
<!--      <div class="intro-y box p-5 mt-5">-->
<!--        <ReportDonutChart :height="210" class="mt-3" />-->
<!--        <div class="mt-8">-->
<!--          <div class="flex items-center">-->
<!--            <div class="w-2 h-2 bg-theme-11 rounded-full mr-3"></div>-->
<!--            <span class="truncate">17 - 30 Years old</span>-->
<!--            <div-->
<!--                class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"-->
<!--            ></div>-->
<!--            <span class="font-medium xl:ml-auto">62%</span>-->
<!--          </div>-->
<!--          <div class="flex items-center mt-4">-->
<!--            <div class="w-2 h-2 bg-theme-1 rounded-full mr-3"></div>-->
<!--            <span class="truncate">31 - 50 Years old</span>-->
<!--            <div-->
<!--                class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"-->
<!--            ></div>-->
<!--            <span class="font-medium xl:ml-auto">33%</span>-->
<!--          </div>-->
<!--          <div class="flex items-center mt-4">-->
<!--            <div class="w-2 h-2 bg-theme-12 rounded-full mr-3"></div>-->
<!--            <span class="truncate">>= 50 Years old</span>-->
<!--            <div-->
<!--                class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"-->
<!--            ></div>-->
<!--            <span class="font-medium xl:ml-auto">10%</span>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!-- END: Sales Report -->
    <!-- BEGIN: Weekly Best Sellers -->
    <div class="col-span-12 xl:col-span-6 mt-6">
      <div class="intro-y flex items-center h-10">
        <h2 class="text-lg font-medium truncate mr-5">Sales</h2>
      </div>
      <div class="mt-5">
        <div
            v-for="dat in data"
            :key="dat.wid"
            class="intro-y"
        >
          <div class="box px-4 py-4 mb-3 flex items-center zoom-in">
            <div
                class="w-10 h-10 flex-none image-fit rounded-md overflow-hidden"
            >
<!--              <img-->
<!--                  alt="Midone Tailwind HTML Admin Template"-->
<!--                  :src="require(`@/assets/images/${faker.photos[0]}`)"-->
<!--              />-->
            </div>
            <div class="ml-4 mr-auto">
              <div class="font-medium">{{ dat.info.name }}</div>
              <div class="text-gray-600 text-xs">

              </div>
            </div>
            <div
                class="py-1 px-2 rounded-full text-xs bg-theme-9 text-white cursor-pointer font-medium"
            >
              {{ dat.info.paid }} Sales
            </div>
          </div>
        </div>
        <a
            href=""
            class="intro-y w-full block text-center rounded-md py-4 border border-dotted border-theme-15 dark:border-dark-5 text-theme-16 dark:text-gray-600"
        >View More</a
        >
      </div>
    </div>
    <!-- END: Weekly Best Sellers -->
  </div>
</template>

<script>
import ReportPieChart from "@/components/ReportPieChart";
import ReportDonutChart from "@/components/ReportDonutChart";
export default {
  props: ["data"],
  data() {
    return {

    }
  },
  methods: {
    getPaidUsers() {
      let sum = 0
      this.data.forEach(o => {sum += o.info.paid})
      return sum
    },
    getRegisteredUsers() {
      let sum = 0
      this.data.forEach(o => {sum += o.info.registered})
      return sum
    },
  },
  components: {
    ReportPieChart,
    ReportDonutChart
  }
}
</script>